import { Flex } from "@mantine/core";
import { useEffect, useMemo } from "react";
import { useFieldArray, useFormContext } from "react-hook-form";
import { useDispatch, useSelector } from "src/redux/hooks";
import { setIsInitialInsert } from "src/redux/slices/generatorSlice";

import SteeringPumpRow from "./SteeringPumpRow";
import { type SteeringPumpRowValue } from "./SteeringPumps.types";

interface Props {
  id: string;
  value: SteeringPumpRowValue[];
}

const pumps = ["Pump 1", "Pump 2"];

const SteeringPumps = ({ id, value }: Props) => {
  useSelector(state => state.entrySlice);
  const { control } = useFormContext();
  const dispatch = useDispatch();
  const { isInitialInsert } = useSelector(state => state.generatorSlice);
  const rows = useMemo(
    () =>
      value && Array.isArray(value) && value.length > 0
        ? value
        : pumps.map(p => ({ label: p, check: false, time: "" })),
    [value],
  );

  const { fields, replace, remove } = useFieldArray({
    name: id,
    control,
  });
  // IMPORTANT: DO NOT CHANGE REPLACING ROWS ON isInitialInsert- this is a workaround for the bug with seetring pumps being re-render with wrong values
  useEffect(() => {
    if (isInitialInsert) {
      dispatch(setIsInitialInsert(false));
      replace(rows);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- deps kept as they were; changing them changes when this runs
  }, [replace, rows]);

  // const handleAppend = useCallback(() => {
  //   append({ label: `Pump ${fields.length + 1}`, check: false, time: "" });
  // }, [append, fields]);

  return (
    <Flex direction="column" gap="md">
      {fields.map((item, index) => (
        <SteeringPumpRow
          key={item.id}
          id={id}
          index={index}
          length={fields.length}
          value={item as unknown as SteeringPumpRowValue}
          remove={remove}
          // disabled={!(noSaves > 0)}
        />
      ))}
      {/* <Button onClick={handleAppend} variant="outline">
        Add Pump +
      </Button> */}
    </Flex>
  );
};

export default SteeringPumps;
